import React from "react";

const Select = React.forwardRef((props, ref) => {
        let options = props.data.map(item =>
            <option value={item.id} key={item.id}>{item.name}</option>
        )

        function handleChange(e) {
            props.handler(e)
        }

        return (
            <select
                className="form-select border"
                disabled={props.disabled}
                id={props.id}
                name={props.name}
                value={props.value}
                onChange={handleChange}
                onBlur={props.onBlurHandle}
                ref={ref}
            >
                <option value=''></option>
                {options}
            </select>
        )
    }
)

export default Select;